<template>
  <div
    class="accessibility-menu-backdrop"
    :class="{ 'is-active': accessibilityIsExpanded }"
  />
  <aside
    :id="accessibilityMenuId"
    ref="accessibilityMenuRef"
    class="accessibility-menu-panel"
    :class="{ 'is-active': accessibilityIsExpanded }"
    :aria-hidden="!accessibilityIsExpanded"
    aria-label="Toegankelijkheidsopties"
  >
    <AccessibilitySelector
      type="list"
      class="accessibility-menu"
      :options="[accessibilityOptions.stimulus, accessibilityOptions.size]"
    />
  </aside>
</template>

<script lang="ts" setup>
  const { accessibilityOptions } = useBaseAccessibility()

  const accessibilityIsExpanded = useState<boolean>('accessibility-menu-expanded', () => false)
  const accessibilityMenuId = 'accessibility-menu-panel'
  const accessibilityMenuRef = ref<HTMLElement | null>(null)

  function handleEscapeKey(event: KeyboardEvent) {
    if (event.key === 'Escape' && accessibilityIsExpanded.value) {
      accessibilityIsExpanded.value = false
    }
  }

  function handleOutsideClick(event: MouseEvent) {
    const target = event.target as Node | null
    if (!target || !accessibilityMenuRef.value) return

    const clickedToggle =
      target instanceof Element && target.closest('[data-accessibility-menu-toggle="true"]') !== null

    if (!accessibilityMenuRef.value.contains(target) && !clickedToggle) {
      accessibilityIsExpanded.value = false
    }
  }

  onMounted(() => {
    document.addEventListener('keydown', handleEscapeKey)
    document.addEventListener('click', handleOutsideClick)
  })

  onUnmounted(() => {
    document.removeEventListener('keydown', handleEscapeKey)
    document.removeEventListener('click', handleOutsideClick)
  })
</script>

<style lang="scss" scoped>
  .accessibility-menu-backdrop {
    position: fixed;
    inset: 0;
    top: var(--header-height);
    z-index: 1001;
    background-color: rgba(0, 0, 0, 0.4);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;

    &.is-active {
      opacity: 1;
      pointer-events: auto;
    }
  }

  .accessibility-menu-panel {
    position: fixed;
    top: var(--header-height);
    right: 0;
    bottom: 0;
    z-index: 1002;
    width: min(24rem, 92vw);
    background-color: $beige;
    color: $black;
    padding: 2.4rem 2rem;
    overflow-y: auto;
    box-shadow: -12px 0 32px rgba(0, 0, 0, 0.18);
    clip-path: inset(0 -40px -40px -40px);
    transform: translateX(100%);
    opacity: 0;
    pointer-events: none;
    transition:
      transform 0.3s ease,
      opacity 0.2s ease;

    &.is-active {
      transform: translateX(0);
      opacity: 1;
      pointer-events: auto;
    }
  }
</style>
